/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_CURRENT_DISPUTE_DISPLAY_OBJ_CODE =
  'GET_CURRENT_DISPUTE_DISPLAY_OBJ_CODE';
export const GET_CURRENT_DISPUTE_DISPLAY_DETAIL_OBJ_CODE =
  'GET_CURRENT_DISPUTE_DISPLAY_DETAIL_OBJ_CODE';
export const GET_PLAN_TYPE_DATA_CODE = 'GET_PLAN_TYPE_DATA_CODE';
export const GET_REBATE_PROGRAM_CODE = 'GET_REBATE_PROGRAM_CODE';
export const GET_REBATE_PROGRAM_NAME_CODE = 'GET_REBATE_PROGRAM_NAME_CODE';
export const GET_ERROR_MSG_DISPUTE_CODE = 'GET_ERROR_MSG_DISPUTE_CODE';
export const MANUFACTURER_GRID_CODE = 'MANUFACTURER_GRID_CODE';
export const SELECT_MANUFACTURER_CODE = 'SELECT_MANUFACTURER_CODE';
export const SET_QUARTER_RANGE_CODE = 'SET_QUARTER_RANGE_CODE';
export const GET_DRUG_SELECTION = 'GET_DRUG_SELECTION';
export const SELECT_DISPUTE_CODE_OPTION = 'SELECT_DISPUTE_CODE_OPTION';
export const SELECTED_DISPUTE_CODE = 'SELECTED_DISPUTE_CODE';
export const GET_MANUFACTURER_NAME_CODE = 'GET_MANUFACTURER_NAME_CODE';
export const GET_MANUFACTURER_ID_CODE = 'GET_MANUFACTURER_ID_CODE';
export const SET_REFRESH_DATA_CODE = 'SET_REFRESH_DATA_CODE';
export const REFRESH_DISPUTE_CODE_DISPLAY = 'REFRESH_DISPUTE_CODE_DISPLAY';
export const SET_STATUS_CODE = 'SET_STATUS_CODE';
export const GET_CODE_NAME_CODE = 'GET_CODE_NAME_CODE';
export const SET_DISPLAY_OBJ_CODE = 'SET_DISPLAY_OBJ_CODE';
export const SET_EXPORT_ALL_CODE = 'SET_EXPORT_ALL_CODE';
export const GET_DISPUTE_CODE_REPORT = 'GET_DISPUTE_CODE_REPORT';

export const SET_PAGINATION_INDEX_DISPUTE_CODES =
  'SET_PAGINATION_INDEX_DISPUTE_CODES';
export const SEARCH_MFG_DISP_ACTIVITY = 'SEARCH_MFG_DISP_ACTIVITY';
